<div class="input-group">
    <button
        class="btn stepper-btn"
        type="button"
        [disabled]="model.isNotDecrementable() || model.options.readonly"
        (click)="decrease()"
    >
        -
    </button>
    <input
        type="text"
        readonly
        [formControl]="durationStepperControl"
        (click)="onClick()"
        class="form-control input-md ps-0 w-100 pe-3"
        paceCoreValidationMessage
        [validation]="durationStepperControl"
        [attr.aria-label]="ariaLabel"
    />
    <button
        class="btn stepper-btn"
        type="button"
        [disabled]="model.isNotIncrementable() || model.options.readonly"
        (click)="increase()"
    >
        +
    </button>
</div>
